import React from "react";
import OverallScoreTab from "./OverallScoreTab.comp";
import ScoreByAgeTab from "./ScoreByAgeTab.comp";
import ScoreByGradeLevelTab from "./ScoreByGradeLevelTab.comp";
import ScoreByClassTab from "./ScoreByClassTab.comp";
import {GET_APP_LOCALIZE_TEXT} from "../../../../utils/dq_lc_service/lc_service";

// Props: processedRubricSchool, assessIndicators, selectedCategory, setSelectedCategory, monthRange, setMonthRange, pageLc, scoresOverviewNationalScores, orgCountry
export function getSchoolScoreTabs(
    processedRubricSchool,
    assessIndicators,
    selectedCategory,
    setSelectedCategory,
    monthRange,
    setMonthRange,
    pageLc,
    scoresOverviewNationalScores,
    orgCountry,
    distributionData
) {
    return [
        {
            key: "overall",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "school_score__overall_performance") || "OVERALL PERFORMANCE",
            path: "overall",
            component: <OverallScoreTab overall={processedRubricSchool.overall} pageLc={pageLc} />,
        },
        {
            key: "by_age",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "school_score__by_age") || "BY AGE",
            path: "by_age",
            component: (
                <ScoreByAgeTab
                    byAgeData={distributionData}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                    scoresOverviewNationalScores={scoresOverviewNationalScores}
                    orgCountry={orgCountry}
                />
            ),
        },
        {
            key: "by_level",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "school_score__by_grade_level") || "BY GRADE LEVEL",
            path: "by_level",
            component: (
                <ScoreByGradeLevelTab
                    byLevelData={distributionData}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                    scoresOverviewNationalScores={scoresOverviewNationalScores}
                    orgCountry={orgCountry}
                />
            ),
        },
        {
            key: "by_class",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "school_score__by_class") || "BY CLASS",
            path: "by_class",
            component: (
                <ScoreByClassTab
                    byClassData={distributionData}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                    scoresOverviewNationalScores={scoresOverviewNationalScores}
                    orgCountry={orgCountry}
                />
            ),
        },
    ];
}
